
<template lang="html">
  <ul class="detail-chapter" ref="chapter">
    <li
      @click="handleSelect(item, index)"
      ref="chapterItem"
      :class="{'checked': activeIndex === chapterIndex ? chapterIndex === index : activeIndex === index}"
      v-for="(item, index) in chapterList"
      :key="item.id">
      <img v-if="activeIndex !== index" src="./images/chapter-play.png" alt="">
      <img v-else src="./images/chapter-play-on.png" alt="">
      {{item.name}}
    </li>
  </ul>
</template>

<script>
import barBus from '../../bar/bus'
import module from '../../modules/audio-detail'
import { mapState, mapActions } from 'vuex'
import record from '../../lib/record'
import keys from 'lodash.keys'

export default {
  name: 'DetailChapter',
  props: ['chapterIndex', 'chapterList', 'hasBuy', 'courseId'],
  data () {
    return {
      itemWidth: 0,
      activeIndex: 0
    }
  },
  computed: {
    ...mapState(module.name, keys(module.modules)),
    chapter () {
      return this.$refs.chapter
    }
  },
  mounted () {
    this.activeIndex = this.chapterIndex
    barBus.$on('scrollList', this.scroll)
    barBus.$on('handleCheckChapter', this.handleSelect)
  },
  methods: {
    ...mapActions(module.name, keys(module.actions)),
    scroll () {
      this.activeIndex = this.chapterIndex
      if (this.$refs.chapterItem[0]) {
        const height = this.$refs.chapterItem[0].clientHeight
        this.$el.scrollTo(0, height*this.chapterIndex);
      }
    },
    handleSelect (chapter, index) {
      barBus.$emit('stopRecord')
      // 未购买且非试看, 不可点击
      if (!chapter) return
      if (!this.hasBuy && chapter.canTry !== 1) {
        this.$toast.show({
          message: '请先购买课程'
        })
        return
      }
      if (chapter.liveState === -1) { // 非直播课
        if (chapter.isPublished) {
          // 区分音/视频详情
          switch (chapter.mediaType) {
            case 1: // 视频
              // window.location.href = `https://edu-m.wps.cn/video-detail?courseId=${this.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`
              this.$router.replace(`/video-detail?courseId=${this.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`)
              break
            case 2: // 音频
              this.activeIndex = index
              this.getMediaData({ chapterId: chapter.id, _this: this })
              this.changeQuickList({ chapterId: chapter.id })
              record.changeChapter(chapter.id)
              this.$router.replace(`/audio-detail?courseId=${this.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`)
             // window.location.href = `https://edu-m.wps.cn/audio-detail?courseId=${this.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`
              break
          }
        }
      } else { // 直播课
        this.$router.replace(`/live?chapterId=${chapter.id}`)
      }
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.detail-chapter {
  height: rem(600);
  width: 100%;
  overflow: scroll;
  margin-top: rem(10);
  line-height: 1.4;
  > li {
    width: 100%;
    display: flex;
    align-items: center;
    height: rem(88);
    font-size: rem(28);
    color: #333333;
    vertical-align: middle;
    &.checked{
      color: #F48F00;
    }
    > img {
      width: rem(48);
      margin-right: rem(16);
    }
  }
}
</style>
